<div *ngIf="fieldOptions">
  <div class="header" style="display: flex; justify-content: space-between; align-items: center;">
    <h2 *ngIf="fieldOptions?.title">{{ fieldOptions?.title }}</h2>
    
    <div style="display: flex; align-items: center;">
      <p-button label="Export CSV" icon="pi pi-file-excel" class="p-mr-2" styleClass="p-button-sm"
        (click)="exportToCSV()">
      </p-button>
      <p-button label="Clear Filters" [badge]="filterCounter" icon="pi pi-filter-slash" class="p-mr-2" styleClass="p-button-sm"
        (click)="clearFilters()">
      </p-button>
      <p-button label="Clear Sorting" [badge]="sortCounter" icon="pi pi-sort-alt-slash" class="p-mr-2" styleClass="p-button-sm"
        (click)="clearSorting()">
      </p-button>
      <!-- Actions Button (only when buildParams are configured) -->
      <p-button *ngIf="buildParams?.assetKeys || buildParams?.imageKeys" label="Actions" icon="pi pi-cog" styleClass="p-button-sm p-mr-2" (click)="showMainTableActions()"></p-button>
      <!-- Expand Popup Button -->
      <p-button label="Expand" icon="pi pi-external-link" styleClass="p-button-sm" (click)="openPopup()"></p-button>
    </div>
  </div>

  <!-- Embedded Table -->
  <app-ag-grid-table
    *ngIf="columnSelection"
    [entity]="fieldOptions?.entity"
    [columnDefs]="fieldOptions?.columnDefs"
    [autopopulateSelect]="fieldOptions?.autopopulateSelect"
    [columnSelection]="columnSelection"
    [isViewEmbedded]="true"
    [tableParams]="tableParams"
    [buildParams]="buildParams"
    [bulkUpdateColDefs]="bulkUpdateColDefs"
    [parentViewName]="parentViewName"
    [customHeight]="fieldOptions?.customHeight"
    [isMultiple]="tableParams.isMultiple || false"
    [context]="{ prizeCounts: prizeCounts }"
    [isPrizeTable]="isPrize"
    [tableIdentifier]="fieldOptions?.identifier || null"
    #mainTable
  ></app-ag-grid-table>

  <!-- Popup Dialog -->
  <p-dialog [(visible)]="showPopup" [modal]="true" [style]="{ width: '90vw', height: '80vh' }" [closable]="true" [draggable]="false" header="Expanded Table" (onHide)="closePopup()">
    <ng-template pTemplate="header">
      <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
        <span>Expanded Table</span>
        <div style="display: flex; align-items: center;">
          <p-button label="Export CSV" icon="pi pi-file-excel" class="p-mr-2" styleClass="p-button-sm"
            (click)="exportPopupToCSV()">
          </p-button>
          <p-button label="Clear Filters" [badge]="popupFilterCounter" icon="pi pi-filter-slash" class="p-mr-2" styleClass="p-button-sm"
            (click)="clearPopupFilters()">
          </p-button>
          <p-button label="Clear Sorting" [badge]="popupSortCounter" icon="pi pi-sort-alt-slash" class="p-mr-2" styleClass="p-button-sm"
            (click)="clearPopupSorting()">
          </p-button>
          <!-- Actions Button (only when buildParams are configured) -->
          <p-button *ngIf="buildParams?.assetKeys || buildParams?.imageKeys" label="Actions" icon="pi pi-cog" styleClass="p-button-sm p-mr-2" (click)="showPopupTableActions()"></p-button>
        </div>
      </div>
    </ng-template>
    <ng-container *ngIf="showPopup">
      <div style="height: auto;">
        <app-ag-grid-table
        [entity]="fieldOptions?.entity"
        [columnDefs]="fieldOptions?.columnDefs"
        [autopopulateSelect]="fieldOptions?.autopopulateSelect"
        [columnSelection]="columnSelection"
        [isViewEmbedded]="true"
        [tableParams]="tableParams"
        [buildParams]="buildParams"
        [bulkUpdateColDefs]="bulkUpdateColDefs"
        [parentViewName]="parentViewName"
        [customHeight]="'60vh'"
        [isMultiple]="tableParams.isMultiple || false"
        [context]="{ prizeCounts: prizeCounts }"
        [isPrizeTable]="isPrize"
        [tableIdentifier]="fieldOptions?.identifier || null"
        #popupTable
      ></app-ag-grid-table>
      </div>
    </ng-container>
  </p-dialog>
</div>
